import * as yup from 'yup';
import * as Schema from '../schemaFields';

export const requestResetPasswordValidationSchema = yup.object({
  email: Schema.email,
});
